import React, { useState, useEffect, useRef } from 'react';
import Modal from 'react-bootstrap/Modal';
import { TextField, Paper, Chip, Autocomplete, CircularProgress, } from '@mui/material';
import ApiService from '../../functions/apiService';
import { Button, Col, Row } from 'react-bootstrap';
import ButtonTheme from '../../components/ThemeButton/ThemeButton';
import { useParams } from "react-router-dom";
import { toast } from 'react-toastify';

const CreateTicket = (props) => {
    let { id, scheduleId } = useParams();
    const { addModal, setAddModal, setViewId, disableItem, ticketAssigned, checklistItemId = '', scheduleReportId = '', getChecklistItems, itemName = '', locName = '' , isStationChecklist = false } = props;
    const [loading, setLoading] = useState(false);
    const [title, setTitle] = useState('');
    const [item, setItem] = useState('');
    const [location, setLocation] = useState('');
    const [description, setDescription] = useState('');
    const [image, setImage] = useState('')
    const [imageTwo, setImageTwo] = useState('')
    const inputFile = useRef(null);
    const [employees, setEmployees] = useState([])
    const [assignTo, setAssignTo] = useState('')

    const loadEmployees = () => {
        setLoading(true);
        ApiService.get('/employee-list-inventory')
            .then(({ data }) => {
                var tempArr = []
                data.data.map((emp) => {
                    // var obj = emp
                    var obj = {
                        label: `${emp.employee_assignment.EA_Rank} ${emp.First_name} ${emp.Last_name}`,
                        value: emp.Emp_Code,
                        firstname: emp.First_name,
                        lastname: emp.Last_name
                    }

                    // obj.label = `${emp.employee_assignment.EA_Rank} ${emp.fullName}`
                    // obj.value = emp.Emp_Code
                    tempArr.push(obj)
                })
                setEmployees(tempArr)
                setLoading(false);
            })
            .catch((e) => {
                setLoading(false);
            })
    }

    useEffect(() => {
        if (ticketAssigned) {
            const tempAssign = employees.find(emp => emp.value === ticketAssigned);
            if (tempAssign) {
                setAssignTo(tempAssign);
            }
        }
    }, [employees, ticketAssigned]);


    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onloadend = () => {
                if (image == '') {
                    setImage(reader.result);
                }
                else {
                    setImageTwo(reader.result);
                }
            };
        }
    };

    const onSubmit = async () => {
        setLoading(true)
        var bodyFormData = new FormData();
        bodyFormData.append('checklist_id', id);
        bodyFormData.append('checklist_schedule_id', scheduleId);
        bodyFormData.append('checklist_item_id', checklistItemId);
        bodyFormData.append('checklist_schedule_report_id', scheduleReportId);
        bodyFormData.append('title', title);
        bodyFormData.append('description', description);
        bodyFormData.append('image', image);
        bodyFormData.append('secondary_image', imageTwo);
        bodyFormData.append('assigned_to', assignTo?.value);
        bodyFormData.append('type', 'base64');
        ApiService.post('/tickets/checklists/create-item', bodyFormData)
            .then((data) => {
                toast.success(data.message)
                getChecklistItems()
                setLoading(false)
                setAddModal(false)
            })
            .catch((error) => {
                setLoading(false)
                if (error.status == 422) {
                    Object.keys(error.data.errors).map((err) => (
                        toast.error(error.data.errors[err][0])
                    ))
                }
                else {
                    toast.error(error.data.message)
                }
            })
    };

    const onSubmitStationChecklist = async () => {
        setLoading(true)
        var bodyFormData = new FormData();
        bodyFormData.append('checklist_id', id);
        bodyFormData.append('checklist_schedule_id', scheduleId);
        bodyFormData.append('checklist_station_item_id', checklistItemId);
        bodyFormData.append('checklist_schedule_report_id', scheduleReportId);
        bodyFormData.append('title', title);
        bodyFormData.append('description', description);
        bodyFormData.append('image', image);
        bodyFormData.append('secondary_image', imageTwo);
        bodyFormData.append('assigned_to', assignTo?.value);
        bodyFormData.append('type', 'base64');
        ApiService.post('/tickets/checklists/station-inspection/create-item', bodyFormData)
            .then((data) => {
                toast.success(data.message)
                getChecklistItems()
                setLoading(false)
                setAddModal(false)
            })
            .catch((error) => {
                setLoading(false)
                if (error.status == 422) {
                    Object.keys(error.data.errors).map((err) => (
                        toast.error(error.data.errors[err][0])
                    ))
                }
                else {
                    toast.error(error.data.message)
                }
            })
    };

    const generalizeTicket = async () => {
        setLoading(true)
        var bodyFormData = new FormData();
        bodyFormData.append('checklist_id', id);
        bodyFormData.append('checklist_schedule_id', scheduleId);
        bodyFormData.append('title', title);
        bodyFormData.append('assigned_to', assignTo?.value);
        bodyFormData.append('description', description);
        bodyFormData.append('image', image);
        bodyFormData.append('secondary_image', imageTwo);
        ApiService.post('/tickets/checklists/create-multiple', bodyFormData)
            .then((data) => {
                toast.success(data.message)
                getChecklistItems()
                setLoading(false)
                setAddModal(false)
            })
            .catch((error) => {
                setLoading(false)
                if (error.status == 422) {
                    Object.keys(error.data.errors).map((err) => (
                        toast.error(error.data.errors[err][0])
                    ))
                }
                else {
                    toast.error(error.data.message)
                }
            })
    };

    useEffect(() => {
        loadEmployees()
        setItem(itemName)
        setLocation(locName)
    }, [itemName])

    return (
        <>
            <Modal show={addModal} size="lg" onHide={() => { setAddModal(false) }}>
                <Modal.Header closeButton>
                    <Modal.Title>Create Ticket</Modal.Title>
                </Modal.Header>
                {loading ?
                    <div style={{ height: 300 }}>
                        <Paper className="w-100 h-100 d-flex justify-content-center align-items-center" style={{ height: 300 }}>
                            <CircularProgress />
                        </Paper>
                    </div>
                    :
                    <Modal.Body>
                        <Row className='w-100' style={{ flexWrap: 'wrap' }}>

                            {/* Title */}
                            <Col md={6}>
                                <label className='my-1'>Title</label>
                                <TextField
                                    className='mt-1 w-100'
                                    color='secondary'
                                    variant="outlined"
                                    value={title}
                                    placeholder="Enter Title"
                                    sx={{
                                        "& .MuiInputBase-root": {
                                            height: '52px',
                                            fontSize: "14px"
                                        }
                                    }}
                                    onChange={(e) => setTitle(e.target.value)}
                                />
                            </Col>

                            {/* Item or Location */}
                            <Col md={6}>
                                <label className='my-1'>{item ? 'Item' : 'Location'}</label>
                                <TextField
                                    className='mt-1 w-100'
                                    color='secondary'
                                    variant="outlined"
                                    value={item ? item : location || 'Generalized Ticket'}
                                    placeholder="Enter Item"
                                    disabled={true}
                                    sx={{
                                        "& .MuiInputBase-root": {
                                            height: '52px',
                                            fontSize: "14px"
                                        }
                                    }}
                                />
                            </Col>

                            {/* Assign to */}
                            <Col md={6}>
                                <label className='mt-3 my-1'>Assign To</label>
                                <Autocomplete
                                    options={employees}
                                    value={assignTo}
                                    defaultValue={ticketAssigned}
                                    onChange={(event, newValue) => { setAssignTo(newValue) }}
                                    getOptionLabel={(option) => option.label}
                                    renderOption={(props, option) => {
                                        const initials = `${option.firstname?.[0] || ''}${option.lastname?.[0] || ''}`;
                                        return (
                                            <li {...props}>
                                                <span className="red-circle">{initials}</span>
                                                {option.label}
                                            </li>
                                        );
                                    }}
                                    sx={{
                                        "& .MuiInputBase-root": {
                                            height: "52px",
                                            fontSize: "14px",
                                            display: "flex",
                                            alignItems: "center",
                                            minHeight: '50px'
                                        }
                                    }}
                                    renderInput={(params) => {
                                        const selectedInitials = ticketAssigned
                                            ? `${assignTo.firstname?.[0] || ''}${assignTo.lastname?.[0] || ''}`
                                            : '';
                                        return (
                                            <TextField
                                                {...params}
                                                className='mt-1 w-100'
                                                placeholder="Assign to"
                                                InputProps={{
                                                    ...params.InputProps,
                                                    startAdornment: ticketAssigned ? (
                                                        <span className="red-circle" style={{ marginLeft: '4px' }}>
                                                            {selectedInitials}
                                                        </span>
                                                    ) : null
                                                }} />);
                                    }}
                                />
                            </Col>

                            {/* Description */}
                            <Col md={12}>
                                <label className='mt-3'>Description</label>
                                <TextField
                                    className='mt-1 w-100'
                                    multiline
                                    color='secondary'
                                    variant="outlined"
                                    value={description}
                                    placeholder="Type message here..."

                                    sx={{
                                        "& .MuiInputBase-root": {
                                            minHeight: '87px'
                                        },
                                        "& .MuiInputBase-input": {
                                            // position: 'absolute',
                                            // top: '13px',
                                            // left: '12px',
                                            alignSelf: 'flex-start'
                                        }
                                    }}
                                    onChange={(e) => setDescription(e.target.value)}
                                />
                            </Col>

                            {/* Image */}
                            <input
                                type="file"
                                ref={inputFile}
                                style={{ display: 'none' }}
                                accept="image/*"
                                onChange={handleFileChange}
                            />

                            <Col md={12}>
                                <label className='mt-3'>Image</label>
                                <div className='mt-1 w-100 img-box'>
                                    {(image && image != '') || (imageTwo && imageTwo != '') ?
                                        <div className='d-flex' style={{ marginRight: 'auto', gap: '12px' }}>
                                            {(image == '' || imageTwo == '') &&
                                                <div onClick={() => inputFile.current.click()}>
                                                    <img src='/images/add-image.png' style={{ width: 70, height: 70, cursor: 'pointer' }} />
                                                </div>
                                            }
                                            {imageTwo && imageTwo != '' &&
                                                <div style={{ contain: 'content' }}>
                                                    <div className='img-cross' onClick={() => setImageTwo('')}>
                                                        <img src='/images/white-cross.png' style={{ width: 10, height: 10 }} />
                                                    </div>

                                                    <img src={imageTwo} style={{ width: 68, height: 68, borderRadius: 50 }} />
                                                </div>
                                            }

                                            {image && image != '' &&
                                                <div style={{ contain: 'content' }}>
                                                    <div className='img-cross' onClick={() => setImage('')}>
                                                        <img src='/images/white-cross.png' style={{ width: 10, height: 10 }} />
                                                    </div>
                                                    <img src={image} style={{ width: 68, height: 68, borderRadius: 50 }} />
                                                </div>
                                            }
                                        </div>
                                        :
                                        <>
                                            <span onClick={() => inputFile.current.click()}><img src='/images/camera.png' style={{ width: 40, height: 40, cursor: 'pointer' }} /></span>
                                            <span>Kindly upload your image</span>
                                        </>
                                    }
                                </div>
                            </Col>
                        </Row>

                        <ButtonTheme type='submit' variant="filled" color='primary' width='20%'
                            className='d-flex px-4 mt-4' onClick={() => disableItem ? generalizeTicket() : isStationChecklist ? onSubmitStationChecklist() : onSubmit()}>
                            Create
                        </ButtonTheme>
                    </Modal.Body>
                }
            </Modal>
        </>
    )
}
export default CreateTicket